import {
	settings,
	TextTokens,
	VIPProject,
	IVIPCertificateMeans,
	IVIPCertificateContact,
	IVIPCertificatePipeline,
	IVIPCertificateProduction,
	IVIPCertificateSubcontracting,
	VIPCertificateConstraint,
	createCertificatePipeline,
	createCertificateMeans,
	createCertificateSubcontracting,
	createCertificateContact,
	checkCertificateContact,
	checkCertificateSubcontracting,
	checkCertificateMeans,
	checkCertificatePipeline
} from "@/loader";


export interface IVIPCertificateData {
	fk_contact?: number;
	contact?: IVIPCertificateContact;
	client?: string;
	manager?: string;
	designation?: string;
	address?: string;
	zipcode?: string;
	isBid?: boolean;
	start?: string;
	end?: string;
	amount?: number;
	amountCompany?: number;
	observations?: string;
	header?: string;
	title?: string;
	price?: string;
	conclusion?: string;
	subcontracting?: IVIPCertificateSubcontracting;
	productions?: IVIPCertificateProduction[];
	means?: IVIPCertificateMeans;
	constraints?: VIPCertificateConstraint;
	pipeline?: IVIPCertificatePipeline;
}

export function createWorkCertificateData(project: VIPProject): IVIPCertificateData {
	let t = new TextTokens(project);

	let data: IVIPCertificateData = {
		fk_contact: 0,
		contact: createCertificateContact(),
		client: project.company?.name || "",
		manager: project.company?.name || "",
		designation: project.description || "",
		address: "",
		zipcode: "",
		isBid: false,
		start: "",
		end: "",
		amount: 0,
		amountCompany: 0,
		observations: t.replace(settings.model_observations),
		subcontracting: createCertificateSubcontracting(),
		productions: [],
		means: createCertificateMeans(),
		constraints: 0,
	};

	if (project.needPipeline) {
		data.pipeline = createCertificatePipeline();
	}

	return data;
}

export function createAbilityCertificateData(project: VIPProject): IVIPCertificateData {
	let t = new TextTokens(project);

	return {
		fk_contact: 0,
		contact: createCertificateContact(),
		header: t.replace(settings.model_header),
		title: t.replace(settings.model_title),
		price: t.replace(settings.model_price),
		subcontracting: createCertificateSubcontracting(t.replace(settings.model_subcontracting)),
		conclusion: t.replace(settings.model_conclusion),
		productions: [],
	};
}

export function checkWorkCertificateData(data: IVIPCertificateData, project: VIPProject | null = null) {
	if (data.fk_contact === undefined) {
		data.fk_contact = 0;
	}
	if (data.contact === undefined) {
		data.contact = createCertificateContact();
	} else {
		checkCertificateContact(data.contact);
	}
	if (data.client === undefined) {
		data.client = project?.company?.name || "";
	}
	if (data.manager === undefined) {
		data.manager = project?.company?.name || "";
	}
	if (data.designation === undefined) {
		data.designation = project?.description || "";
	}
	if (data.address === undefined) {
		data.address = "";
	}
	if (data.zipcode === undefined) {
		data.zipcode = "";
	}
	if (data.isBid === undefined) {
		data.isBid = false;
	}
	if (data.start === undefined) {
		data.start = "";
	}
	if (data.end === undefined) {
		data.end = "";
	}
	if (data.amount === undefined) {
		data.amount = 0;
	}
	if (data.amountCompany === undefined) {
		data.amountCompany = 0;
	}
	if (data.observations === undefined) {
		data.observations = "";
	}
	if (data.subcontracting === undefined) {
		data.subcontracting = createCertificateSubcontracting();
	} else {
		checkCertificateSubcontracting(data.subcontracting);
	}
	if (data.productions === undefined) {
		data.productions = [];
	}
	if (data.means === undefined) {
		data.means = createCertificateMeans();
	} else {
		checkCertificateMeans(data.means);
	}
	if (data.constraints === undefined) {
		data.constraints = 0;
	}
	if (data.pipeline === undefined && project?.needPipeline) {
		data.pipeline = createCertificatePipeline();
	} else if (data.pipeline && project?.needPipeline) {
		checkCertificatePipeline(data.pipeline);
	}
}

export function checkAbilityCertificate(data: IVIPCertificateData, project: VIPProject | null = null) {
	let t = new TextTokens(project);

	if (data.fk_contact === undefined) {
		data.fk_contact = 0;
	}
	if (data.contact === undefined) {
		data.contact = createCertificateContact();
	} else {
		checkCertificateContact(data.contact);
	}
	if (data.header === undefined) {
		data.header = t.replace(settings.model_header);
	}
	if (data.title === undefined) {
		data.title = t.replace(settings.model_title);
	}
	if (data.price === undefined) {
		data.price = t.replace(settings.model_price);
	}
	if (data.subcontracting === undefined) {
		data.subcontracting = createCertificateSubcontracting(t.replace(settings.model_subcontracting));
	} else {
		checkCertificateSubcontracting(data.subcontracting);
	}
	if (data.conclusion === undefined) {
		data.conclusion = t.replace(settings.model_conclusion);
	}
	if (data.productions === undefined) {
		data.productions = [];
	}
}
